module.exports = __webpack_public_path__ + "static/media/gameLabDiagnosis.eb1b11b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameLabDiagnosis.png
// module id = 2242
// module chunks = 0